import React, { useState, useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import axios from "axios";

const AdminJobDetails = () => {
  const jobsData = useLoaderData(); // Get the job details (e.g., jobId)
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);

  const fetchJobs = async (currentPage) => {
    try {
      const response = await axios.get("https://mirai-server.vercel.app/api/career", {
        params: {
          page: currentPage,
          jobId: jobsData._id, // Pass jobId as a query parameter
        },
      });

      setJobs(response.data.data);
      setPage(response.data.page);
      setTotalPages(response.data.pages);
      setHasNextPage(response.data.hasNextPage);
      setHasPrevPage(response.data.hasPrevPage);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  useEffect(() => {
    fetchJobs(page);
  }, [page, jobsData._id]);

  return (
    <div>
      <div className="w-full py-6 border-b border-gray-300 px-6">
        <h1 className="text-2xl font-bold text-gray-700 font-roboto">
          Applicant CV
        </h1>
      </div>
      <h1 className="m-5 text-xl font-semibold text-gray-800 font-roboto">
        Job title: {jobsData.title}
      </h1>
      <div className="grid grid-cols-3 gap-5 mt-10 mx-5">
        {jobs.map((job) => (
          <div
            className="w-full p-5 border border-gray-400 rounded-xl flex flex-col gap-2"
            key={job._id}
          >
            <div>
              <h3 className="text-md text-gray-500  font-roboto">
                Job Id: {job.jobId}
              </h3>
            </div>
            <h3 className="text-lg text-gray-700 font-roboto">
              Applicant Name: {job.name}
            </h3>

            <h3 className="text-lg text-gray-700  font-roboto">
              Email: {job.email}
            </h3>
            <h3 className="text-lg text-gray-700  font-roboto">
              Phone: {job.phone}
            </h3>
            <h3 className="text-lg text-gray-700  font-roboto">
              Address: {job.address}
            </h3>
            <h3 className="text-lg text-gray-700  font-roboto">
              Expected Salary {job.expectedSalary}
            </h3>
            <h3 className="text-lg text-gray-700  font-roboto">
              Apply Date: {new Date(job.createdAt).toDateString()}
            </h3>

            <div className="flex flex-row gap-4">
              <h1 className="text-lg text-gray-700  font-roboto">
                Applicant CV
              </h1>
              <a target="_blank" href={job.pdfUrl}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="25"
                  viewBox="0 0 19 25"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.25461 0H11.6129L18.6969 7.38381V21.7454C18.6969 23.5445 17.2414 25 15.4485 25H3.25461C1.45552 25 5.1412e-10 23.5445 5.1412e-10 21.7454V3.25461C-3.15869e-05 1.45552 1.45549 0 3.25461 0Z"
                    fill="#E5252A"
                  />
                  <path
                    opacity="0.302"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.6074 0V7.32759H18.6976L11.6074 0Z"
                    fill="white"
                  />
                  <path
                    d="M3.61816 18.6531V14.0867H5.56095C6.04196 14.0867 6.42303 14.2179 6.71038 14.4865C6.99774 14.7488 7.14143 15.1049 7.14143 15.5484C7.14143 15.992 6.99774 16.348 6.71038 16.6104C6.42303 16.879 6.04196 17.0102 5.56095 17.0102H4.78633V18.6531H3.61816ZM4.78633 16.017H5.42977C5.60467 16.017 5.7421 15.9795 5.83582 15.892C5.92951 15.8108 5.97951 15.6984 5.97951 15.5485C5.97951 15.3986 5.92954 15.2861 5.83582 15.2049C5.74213 15.1174 5.6047 15.08 5.42977 15.08H4.78633V16.017ZM7.62241 18.6531V14.0867H9.24035C9.55894 14.0867 9.8588 14.1304 10.1399 14.2241C10.421 14.3178 10.6771 14.449 10.902 14.6302C11.1269 14.8051 11.3081 15.0424 11.4392 15.3423C11.5642 15.6422 11.6329 15.9857 11.6329 16.373C11.6329 16.7541 11.5642 17.0977 11.4392 17.3975C11.3081 17.6974 11.1269 17.9347 10.902 18.1096C10.6771 18.2908 10.421 18.422 10.1399 18.5157C9.8588 18.6094 9.55894 18.6531 9.24035 18.6531H7.62241ZM8.76559 17.6599H9.10291C9.28407 17.6599 9.45274 17.6412 9.60891 17.5974C9.75882 17.5537 9.90252 17.485 10.04 17.3913C10.1711 17.2976 10.2773 17.1664 10.3523 16.9915C10.4272 16.8166 10.4647 16.6104 10.4647 16.373C10.4647 16.1294 10.4272 15.9233 10.3523 15.7484C10.2773 15.5735 10.1711 15.4423 10.04 15.3486C9.90252 15.2549 9.75886 15.1861 9.60891 15.1424C9.45274 15.0987 9.28407 15.0799 9.10291 15.0799H8.76559V17.6599ZM12.2201 18.6531V14.0867H15.4685V15.0799H13.3883V15.8108H15.0499V16.7978H13.3883V18.6531H12.2201Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        ))}
      </div>
      <div class="flex flex-col items-center mt-10">
        <span class="text-sm font-roboto text-gray-700 dark:text-gray-400">
          {`Page ${page} of ${totalPages}`}
        </span>
        <div class="inline-flex mt-2 xs:mt-0">
          <button
            onClick={() => setPage(page - 1)}
            disabled={!hasPrevPage}
            class="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-gray-800 rounded-s hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            <svg
              class="w-3.5 h-3.5 me-2 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 5H1m0 0 4 4M1 5l4-4"
              />
            </svg>
            Prev
          </button>
          <button
            onClick={() => setPage(page + 1)}
            disabled={!hasNextPage}
            class="flex items-center justify-center px-3 h-8 text-sm font-medium text-white bg-gray-800 border-0 border-s border-gray-700 rounded-e hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          >
            Next
            <svg
              class="w-3.5 h-3.5 ms-2 rtl:rotate-180"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M1 5h12m0 0L9 1m4 4L9 9"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminJobDetails;
